import React from 'react';
import { ProductFactory } from '../productConfig/productFactory';
import { Tag } from './Tag';

export const Product = ({
  product,
  carrier,
  subCategory,
}: {
  product: string;
  carrier: string;
  subCategory: string;
}) => {
  let clr = 'LgaBlue';
  const productConfig = ProductFactory.getProductConfig(
    carrier,
    product,
    subCategory,
  );
  if (productConfig) {
    clr = productConfig.getColor();
  }
  const defaultLabel = `${carrier} ${product}`;
  return (
    <Tag color={clr}>
      {productConfig?.getProductDisplayText() ?? defaultLabel}
    </Tag>
  );
};
